











































































































































































import { Vue, Component, Ref, PropSync, Watch } from 'vue-property-decorator'
import { FormTurnoDeVenda } from '@/models/venda/TurnoDeVenda'
import CampoDecimal from '@/components/ui/CampoDecimal.vue'
import SeletorDePdv from '@/components/venda/SeletorDePdv.vue'
import { PontoDeVenda, Usuario } from '@/models'
import { obrigatorio, positivo } from '@/shareds/regras-de-form'
import { AbrirCaixaUseCase, EditarPdvUseCase, FindFechamentoDeCaixaUseCase, FindLojaUseCase } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import Tarefa from '@/helpers/Tarefa'
import { VendaModule } from '@/store/vuex/venda/VendaStore'

const ULTIMO_PDV = 'ultimo-pdv'

@Component({
	components: {
		SeletorDePdv,
		CampoDecimal,
	},
})
export default class DialogoDeAberturaDeCaixa extends Vue {
	@PropSync('value') mostra!: boolean | null
	@Ref() botaoDePdv!: { $el: HTMLButtonElement }
	@Ref() campoDeTroco!: CampoDecimal
	@Ref() form!: HTMLFormElement

	abrirCaixaUseCase = new AbrirCaixaUseCase()
	findFechamentoDeCaixaUseCase = new FindFechamentoDeCaixaUseCase()
	mostraSeletorDePdv = false
	liberarCampoDoTroco = false
	abrirDialogoDeMotivo = false
	verificandoTroco = false
	trocoAlterado = false
	motivoSalvo = false
	salvando = false
	carregando = false
	obrigatorio = obrigatorio
	observacao = ''
	positivo = positivo
	usuario: Usuario | null = null
	troco: null | number = null 
	setarUsuarioLogado = new EditarPdvUseCase()

	turnoDeVenda: FormTurnoDeVenda = {
		pontoDeVenda: localStorage[ULTIMO_PDV]
			? JSON.parse(localStorage[ULTIMO_PDV])
			: null,
		fechamento: null,
		movimentacoes: [],
		tiposDePagamento: [],
		operador: null,
	}

	tarefaDeAbertura = new Tarefa('abrirCaixa', this.abrirCaixa)
	findLojaUseCase = new FindLojaUseCase()

	created(){
		this.usuario = UserLoginStore.usuario
		this.turnoDeVenda.pontoDeVenda.id ? this.buscarTroco() : null;
	}

	get nomeEPerfilDoUsuario(){
		if(!this.usuario) return ''
		return `${this.usuario?.nome} - ${this.usuario?.perfil.nome}`
	}
	
	@Watch('mostra')
	onChangeMostra(mostra: boolean) {
		if (mostra) {
			if(this.turnoDeVenda.pontoDeVenda) {
				this.buscarTroco()
			}
			setTimeout(() => {
				if (!this.turnoDeVenda.pontoDeVenda) {
					this.mostraSeletorDePdv = true
				} else {
					this.campoDeTroco.focus()
				}
			})
		} else {
			this.trocoAlterado = false
			this.verificandoTroco = false
			this.motivoSalvo = false
		}
	}

	async authentication() {
		this.carregando = true	
		try{
			const loja = await this.findLojaUseCase.findLojaByPdv(this.turnoDeVenda.pontoDeVenda.id)
			const autenticacaoObrigatoria = loja.configuracaoDaLoja.deveAutenticarParaAlterarTroco

			if(!autenticacaoObrigatoria) {
				this.liberarCampoDoTroco = true
			} else {
				if(await VendaModule.autenticarAcaoTelaDeCaixa({ regra:'pode-alterar-troco-no-caixa' })) {
					this.liberarCampoDoTroco = true
				}
			}
			this.motivoSalvo = false
			this.trocoAlterado = false
		}catch(e) {
			AlertModule.setError(e)
		} finally {
			this.carregando = false
		}
	}

	async verificaAlteracaoDeTroco() {
		try {
			if(!UserLoginStore.usuario) return 
			this.verificandoTroco = true
			const pdvId = this.turnoDeVenda.pontoDeVenda.id
			const troco = await this.findFechamentoDeCaixaUseCase.findValorContadoEmDinheiroByPdvId(pdvId)
			const loja = await this.findLojaUseCase.findLojaByPdv(this.turnoDeVenda.pontoDeVenda.id)
			const autenticacaoObrigatoria = loja.configuracaoDaLoja.deveAutenticarParaAlterarTroco
			const operadorId = UserLoginStore.usuario.id

			await this.setarUsuarioLogado.setarUsuarioLogado(pdvId, operadorId)
			
			if (autenticacaoObrigatoria === true) {
				if (this.troco !== troco) {
					this.abrirDialogoDeMotivo = true
					this.trocoAlterado = true
					this.verificandoTroco = false
				} else {
					await this.confirmar()
				}
			} else {
				await this.confirmar()
			} 
		} catch(error) {
			AlertModule.setError(error)
		}
	}

	fechaDialogoDeMotivo() {
		const campo = this.$refs.campoDeMotivo as any
		if (!campo.validate()) return
	
		this.abrirDialogoDeMotivo = false
		this.motivoSalvo = true
	}

	async confirmar() {
		if (this.trocoAlterado && !this.motivoSalvo) {
			this.abrirDialogoDeMotivo = true
			return
		}
	
		this.tarefaDeAbertura.executar()
	}

	async abrirCaixa() {
		if (!this.form.validate()) return
		if (!this.turnoDeVenda.pontoDeVenda) {
			this.mostraSeletorDePdv = true
			return
		}

		delete this.turnoDeVenda.pontoDeVenda['loja']
		const turnoDeVenda: FormTurnoDeVenda = {
			...this.turnoDeVenda,
			pontoDeVenda: this.turnoDeVenda.pontoDeVenda,
			movimentacoes: [
				{
					id: '',
					tipoMovimentacao: 'Abertura',
					valor: this.troco as number,
					dataHoraMovimentacao: new Date(),
					observacao: this.observacao,
					anexos: [],
					operador: null,
					motivo: null,
				},
			],
		}

		try {
			const turnoAberto = await this.abrirCaixaUseCase.execute(turnoDeVenda)
			localStorage[ULTIMO_PDV] = JSON.stringify(
				this.turnoDeVenda.pontoDeVenda,
			)
			this.$emit('abriu', turnoAberto)
			this.verificandoTroco = false
		} catch (e) {
			AlertModule.setError(e)
		}
	}

	selecionarPdv(pdv: PontoDeVenda) {
		this.turnoDeVenda.pontoDeVenda = pdv
		this.buscarTroco()
		this.mostraSeletorDePdv = false
		setTimeout(() => {
			this.campoDeTroco.focus()
		})
	}

	async buscarTroco() {
		try {
			if(!this.turnoDeVenda.pontoDeVenda.id) return

			const pdvId = this.turnoDeVenda.pontoDeVenda.id
			const troco = await this.findFechamentoDeCaixaUseCase.findValorContadoEmDinheiroByPdvId(pdvId)
			this.troco = troco
		} catch(e) {
			AlertModule.setError(e)
		}
	}

	get permiteAlterarTrocoNoCaixa() {
		return UserLoginStore.permiteRegraDeNegocio('pode-alterar-troco-no-caixa') || this.liberarCampoDoTroco
	}
}
